export default __webpack_public_path__ + "static/media/12.4da54f3e.png";